module.exports = __webpack_public_path__ + "img/robber.f158d97a.svg";